document.addEventListener('DOMContentLoaded', function () {

  const modal = document.getElementById('rgoPreviewModal');
  const modalImage = document.getElementById('rgoPreviewImage');
  const modalImageWrap = document.querySelector('.rgo-preview-modal__image-wrap');

  const modalTitle = document.getElementById('rgoPreviewTitle');
  const modalPrice = document.getElementById('rgoPreviewPrice');
  const modalLink = document.getElementById('rgoPreviewLink');

  const previewButtons = document.querySelectorAll('[data-preview]');
  const closeButtons = document.querySelectorAll('[data-modal-close]');

  if (
    !modal ||
    !modalImage ||
    !modalImageWrap ||
    !modalTitle ||
    !modalPrice ||
    !modalLink
  ) {
    return;
  }


  /* ========================================
     Fallback Image
  ======================================== */

  const fallbackImage = modalImage.dataset.fallback;


  modalImage.addEventListener('error', function () {

    if (fallbackImage && this.src !== fallbackImage) {
      this.src = fallbackImage;
    }

  });


  /* ========================================
     Open Preview
  ======================================== */

  function openPreview(button) {

    const title = button.dataset.title || '';
    const price = button.dataset.price || '';
    const image = button.dataset.image || fallbackImage || '';
    const url = button.dataset.url || '#';

    modalTitle.textContent = title;
    modalPrice.textContent = price;
    modalLink.href = url;

    /*
     * Reset image zoom before opening
     */
    modalImageWrap.classList.remove('is-zooming');

    modalImage.style.transformOrigin = 'center center';

    /*
     * Reset fallback state
     */
    if (fallbackImage) {
      modalImage.src = fallbackImage;
    }

    /*
     * Load product image
     */
    if (image) {
      modalImage.src = image;
    }

    modalImage.alt = title;

    /*
     * Open modal
     */
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    /*
     * Prevent page scrolling
     */
    document.body.style.overflow = 'hidden';
  }


  /* ========================================
     Close Preview
  ======================================== */

  function closePreview() {

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    /*
     * Reset zoom
     */
    modalImageWrap.classList.remove('is-zooming');

    modalImage.style.transformOrigin = 'center center';

    /*
     * Restore page scrolling
     */
    document.body.style.overflow = '';

    /*
     * Return to fallback image after
     * the closing animation
     */
    setTimeout(function () {

      if (fallbackImage) {
        modalImage.src = fallbackImage;
      } else {
        modalImage.removeAttribute('src');
      }

    }, 250);
  }


  /* ========================================
     Preview Buttons
  ======================================== */

  previewButtons.forEach(function (button) {

    button.addEventListener('click', function (event) {

      /*
       * Prevent navigation
       */
      event.preventDefault();
      event.stopPropagation();

      openPreview(button);

    });

  });


  /* ========================================
     Mouse Zoom
  ======================================== */

  modalImageWrap.addEventListener('mouseenter', function () {

    modalImageWrap.classList.add('is-zooming');

  });


  /* ========================================
     Mouse Pan
  ======================================== */

  modalImageWrap.addEventListener('mousemove', function (event) {

    const rect = modalImageWrap.getBoundingClientRect();

    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;

    modalImage.style.transformOrigin =
      `${xPercent}% ${yPercent}%`;

  });


  /* ========================================
     Mouse Leave
  ======================================== */

  modalImageWrap.addEventListener('mouseleave', function () {

    modalImageWrap.classList.remove('is-zooming');

    modalImage.style.transformOrigin =
      'center center';

  });


  /* ========================================
     Close Buttons / Overlay
  ======================================== */

  closeButtons.forEach(function (button) {

    button.addEventListener('click', function () {

      closePreview();

    });

  });


  /* ========================================
     Escape Key
  ======================================== */

  document.addEventListener('keydown', function (event) {

    if (
      event.key === 'Escape' &&
      modal.classList.contains('is-open')
    ) {

      closePreview();

    }

  });


  /* ========================================
     Prevent Modal Content Click
     From Closing
  ======================================== */

  const modalDialog =
    modal.querySelector('.rgo-preview-modal__dialog');

  if (modalDialog) {

    modalDialog.addEventListener('click', function (event) {

      event.stopPropagation();

    });

  }
});

/* ------------------------
Hero and bottom CTA buttons
--------------------------*/

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-scroll-target]');

  if (!button) return;

  const targetId = button.dataset.scrollTarget;
  const target = document.getElementById(targetId);

  if (!target) return;

  event.preventDefault();

  target.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
});